import script from "./PgmLayout.vue?vue&type=script&setup=true&lang=ts"
export * from "./PgmLayout.vue?vue&type=script&setup=true&lang=ts"

import "./PgmLayout.vue?vue&type=style&index=0&id=f738a784&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f738a784"]])

export default __exports__